import carousel from 'van11y-accessible-carrousel-aria';
import PL_utils from './vendor/pl-utils.js';

const isEDMode = window.location.href.indexOf('ed=1') >= 0;

const AUTO_INTERVAL = 5000;
const WAIT_500 = 1000;
const NEXT_BUTTON = '.header-carrousel__button__next .header-carrousel__button__button';
const DOT_BUTTON = '.header-carrousel__control__list__link';
const HOVER_BUTTON = '.header-carrousel__control__list__item';
const playButton = document.querySelector('.header-carrousel__button-play');
const pauseButton = document.querySelector('.header-carrousel__button-pause');


const carouselInit = () => {
    // Start the carousel and auto play on an interval.
    let autoCarousel = setInterval(() => { autoPlayNextCarousel(); }, AUTO_INTERVAL);

    const pauseCarousel = () => {
        clearInterval(autoCarousel);
        PL_utils.addClass('button-inactive', pauseButton);
        PL_utils.removeClass('button-inactive', playButton);
    }

    const playCarousel = () => {
        const nextButton = document.querySelector(NEXT_BUTTON);
        nextButton.click();

        autoCarousel = setInterval(() => {
            autoPlayNextCarousel();
        }, AUTO_INTERVAL);
        PL_utils.addClass('button-inactive', playButton);
        PL_utils.removeClass('button-inactive', pauseButton);
    }

    // Programmatically play and change slides for the autoplay carousel.
    // Note: auto play doesn't include clicking NEXT_BUTTON, as it forces the screen reader to focus on the carousel. Autoplay should be allowed to run in the background without forcing the user to focus back.
    const autoPlayNextCarousel = () => {
        const carouselContainer = document.querySelector('.header-carrousel__container');
        const currentSlide = carouselContainer.getAttribute('data-carrousel-active-slide');
        const allSlides = carouselContainer.querySelectorAll('.carrousel__content');
        const totalSlides = allSlides.length;

        let nextSlide = Number(currentSlide);
        if (Number(currentSlide) === totalSlides) {
            // If slideshow has reached the end, go back to the beginning.
            nextSlide = 1;
        } else if (Number(currentSlide) < totalSlides) {
            // Otherwise, increment the slide number.
            nextSlide += 1;
        }

        const nextContainer = allSlides[nextSlide - 1];
        const currentContainer = allSlides[currentSlide - 1];

        // Set the active slide to the next slide number.
        carouselContainer.setAttribute('data-carrousel-active-slide', nextSlide.toString());
        // Hide the current/previous slide and toggle the next slide for screen readers.
        nextContainer.setAttribute('aria-hidden', false);
        currentContainer.setAttribute('aria-hidden', true);

        const currentControl = document.querySelector(`[data-carrousel-control-element-number="${currentSlide}"]`);
        const nextControl = document.querySelector(`[data-carrousel-control-element-number="${nextSlide}"]`);

        // Remove the selected state from the previous/current control button.
        currentControl.setAttribute('tabindex', '-1');
        currentControl.setAttribute('aria-selected', false);
        // Add selected state to the next control button.
        nextControl.setAttribute('tabindex', '0');
        nextControl.setAttribute('aria-selected', true);
    };

    const resetCarousel = () => {
        clearInterval(autoCarousel);
        autoCarousel = setInterval(() => { autoPlayNextCarousel(); }, AUTO_INTERVAL);
    }

    pauseButton.addEventListener('click', (e) => {
        e.preventDefault();
        pauseCarousel();
    })

    playButton.addEventListener('click', (e) => {
        e.preventDefault();
        playCarousel();
    })

    setTimeout(() => {
        let dotButtons = document.querySelectorAll(DOT_BUTTON);
        PL_utils.eleOnClick(() => {
            resetCarousel();
            PL_utils.addClass('button-inactive', playButton);
            PL_utils.removeClass('button-inactive', pauseButton);
        }, dotButtons);
    }, WAIT_500);

    //check if it's andorid phone
    setTimeout(() => {
        if (navigator.userAgent.match(/android/i)){
            let target = document.querySelectorAll(HOVER_BUTTON);
           target.forEach((el)=>{
               //add styles specificaly for andorid
               PL_utils.addClass('android-padding', el);
           })
        }
    }, WAIT_500)
}

//screenshot
const screenshot = () => {
    if(window.location.href.indexOf('carousel-slide=1') > 0){
        setTimeout(() => {
            const nextButton = document.querySelector(NEXT_BUTTON);
            nextButton.click();
        }, WAIT_500);
    }

    if (window.location.href.indexOf('carousel-slide=2') > 0) {
        setTimeout(() => {
            const nextButton = document.querySelector(NEXT_BUTTON);
            nextButton.click();
            nextButton.click();
        }, WAIT_500);
    }

    if (window.location.href.indexOf('carousel-button=play') > 0) {
        PL_utils.addClass('button-inactive', pauseButton);
        PL_utils.removeClass('button-inactive', playButton);
    }

    if (window.location.href.indexOf('carousel-button=hover') > 0) {
        setTimeout(() => {
            const dot = document.querySelectorAll('.header-carrousel__control__list__link');
            PL_utils.addClass('hover-ss', dot[dot.length - 1]);
        }, WAIT_500);
    }
}

export default () => {

    if (isEDMode) {
        screenshot();
    } else if(document.querySelector('.js-carrousel')){
       carouselInit();
    }

}
